import {Component, Input, OnInit, TemplateRef} from "@angular/core";
import {NavigationStart, Router} from "@angular/router";
import {DialogComponent} from "../../../../ng2-bootstrap-modal/dialog.component";
import {TypeUtils} from "../../utils/type-utils";
import {Store} from "@ngrx/store";
import {filter, first, switchMap} from "rxjs/operators";
import * as fromStore from '../../../store';
import {IActivity} from "../../../activities/activity";
import {DbActiveModal} from "../../../modules/modal/modal-ref";

@Component({
    selector: 'db-dialog-wrapper',
    templateUrl: './dialog-wrapper.component.html',
    styleUrls: ['./dialog-wrapper.component.scss'],
    standalone: false
})
export class DialogWrapperComponent implements OnInit {
  @Input() dialog: DialogComponent<any, any>;
  @Input() width?: string;
  @Input() height?: string;
  @Input() fullScreen?: boolean;
  @Input() fullScreenWithPadding?: boolean;
  @Input() whiteCloseBtn?: boolean = false;
  @Input() hasCloseButton?: boolean = true;
  @Input() hasExternalCloseButton?: boolean = false;
  @Input() canClose?: boolean = true;
  @Input() canCloseByBackdrop?: boolean = true;
  @Input() closeButtonTop?: string;
  @Input() closeButtonRight?: string;
  @Input() animateShow?: boolean;
  @Input() animateHide?: boolean;
  @Input() clean?: boolean;
  @Input() noBorder?: boolean;
  @Input() className?: string;
  @Input() migrationProgress?: boolean;
  @Input() customScrollScreen?: boolean = false;
  @Input() direct?: boolean = true;
  @Input() template?: TemplateRef<any>;
  @Input() withBlur: boolean = false;
  @Input() withBlackBlur: boolean = false;

  constructor(
    private _router: Router,
    private readonly _activeModal: DbActiveModal,
    private _store: Store<fromStore.DbStoreState>
  ) {
    this._router.events
      .pipe(filter((event: any) => event instanceof NavigationStart),
      first())
      .subscribe((_e) => {
        this.close();
      });
  }

  ngOnInit(): void {
    this.animateShow = TypeUtils.isUndefined(this.animateShow) ? true : this.animateShow;
    this.animateHide = TypeUtils.isUndefined(this.animateHide) ? true : this.animateHide;
  }

  public close(): void {
    if ( this.canClose && this.dialog) {
      if (!this.direct) {
        this._store.select(fromStore.getOngoingActivitiesInited)
          .pipe(
            filter((ongoingActivitiesInited) => ongoingActivitiesInited),
            switchMap(() => this._store.select(fromStore.getMigrationOngoingActivity)),
          )
          .subscribe((migrationActivity: IActivity) => {
            if (!migrationActivity) {
              this._activeModal.close();
              this.dialog.close();
              return;
            }
            if ( migrationActivity.meta && migrationActivity.meta.migrating_domain_id && typeof(this.migrationProgress) !== 'undefined' && this.migrationProgress ) {
              if ( this._router.url.indexOf(migrationActivity.meta.migrating_domain_id) > -1 ) {
                this._router.navigate(['/websites']);
              }
              this._activeModal.close();
              this.dialog.close();
            }
            else {
              this._activeModal.close();
              this.dialog.close();
              return;
            }
          });
      }
      else {
        this.dialog.close();
        this._activeModal.close();
      }
    }
  }

  public closeByBackdrop(): void {
    this.canCloseByBackdrop && this.close();
  }

}
